module.exports = __webpack_public_path__ + "static/media/13-13.2471918c.mp3";